import React from 'react';
import { Radio, Badge, Tooltip } from 'antd';
import Translate from 'react-translate-component';

import withFieldWrapper from 'components/hocs/withFieldWrapper';
import { RadioButtons } from './RadioButtons';
import CustomIcon from 'components/common/CustomIcon';

class RadioIcons extends RadioButtons {
    renderOptions() {
        const { options, namePath, useBadge } = this.props;

        return options.map(
            ({ id, [namePath] : translate, className }) => (
                <Radio key={id} value={id} onClick={() => this.onClick(id)}>
                    <Tooltip title={translate ? <Translate content={translate} /> : null} placement="top">
                        {useBadge ? <Badge count={id} className={className} /> : <CustomIcon type={id}/>}
                    </Tooltip>
                </Radio>
            )
        );
    }
}

export default withFieldWrapper(RadioIcons);
